export function cn(...a) { return a.filter(Boolean).join(" "); }

export const STATUS_STYLES = {
  ONLINE: { text: "#34D399", bg: "rgba(6,78,59,0.4)", border: "rgba(16,185,129,0.5)", dot: "#10B981" },
  OFFLINE: { text: "#F87171", bg: "rgba(136,19,55,0.35)", border: "rgba(239,68,68,0.5)", dot: "#EF4444" },
  DEGRADED: { text: "#FBBF24", bg: "rgba(120,53,15,0.4)", border: "rgba(245,158,11,0.5)", dot: "#F59E0B" },
  MAINTENANCE: { text: "#38BDF8", bg: "rgba(12,74,110,0.4)", border: "rgba(14,165,233,0.5)", dot: "#0EA5E9" },
  UNKNOWN: { text: "#94A3B8", bg: "rgba(30,41,59,0.6)", border: "rgba(100,116,139,0.4)", dot: "#64748B" },
};

export const SEVERITY_CLASS = {
  EMERGENCY: "bg-rose-950 text-rose-200 border-rose-700",
  CRITICAL: "bg-rose-950/80 text-rose-300 border-rose-800/80",
  HIGH: "bg-orange-950/80 text-orange-300 border-orange-800/80",
  WARNING: "bg-amber-950/80 text-amber-300 border-amber-800/80",
  MEDIUM: "bg-amber-950/80 text-amber-300 border-amber-800/80",
  LOW: "bg-slate-800/80 text-slate-300 border-slate-700/80",
  INFO: "bg-sky-950/80 text-sky-300 border-sky-800/80",
  INFORMATIONAL: "bg-sky-950/80 text-sky-300 border-sky-800/80",
};

export const RISK_CLASS = {
  LOW: "bg-emerald-950/70 text-emerald-300 border-emerald-800/70",
  MEDIUM: "bg-amber-950/70 text-amber-300 border-amber-800/70",
  HIGH: "bg-orange-950/70 text-orange-300 border-orange-800/70",
  CRITICAL: "bg-rose-950/80 text-rose-300 border-rose-800/80",
};

export function timeAgo(iso) {
  if (!iso) return "never";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

export function fmtUptime(sec) {
  if (!sec) return "—";
  const d = Math.floor(sec / 86400), h = Math.floor((sec % 86400) / 3600), m = Math.floor((sec % 3600) / 60);
  return d ? `${d}d ${h}h` : h ? `${h}h ${m}m` : `${m}m`;
}
